import PlainTextCell from 'components/PlainTextCell';

import { parseDate } from 'utils/dates';

type Props = {
  rowData: Pick<SentinelTeam, 'createdAt' | 'scheduledForDeletionAt'>;
};

export default function CreatedAtCell({
  rowData: { createdAt, scheduledForDeletionAt },
}: Props) {
  const [topLine, bottomLine] = parseDate(createdAt);

  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      {...{ topLine, bottomLine }}
    />
  );
}
